import { render } from "./TabPersonalInformation.vue?vue&type=template&id=01853873&ts=true"
import script from "./TabPersonalInformation.vue?vue&type=script&lang=ts"
export * from "./TabPersonalInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__